import { Splide } from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';


const company = () => {
  const targetElm = document.getElementById('js-company');
  if(!targetElm) return;
  const options = {
    type: 'loop',
    speed: 400,
    interval: 3000,
    autoWidth: true,
    arrows: false,
    pagination: false,
    drag: false,
    autoScroll: {
      speed: 1.25,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    reduceMotion: {
      speed: 400,
      interval: 3000,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoScroll: {
        speed: 1.25,
      }
    }
  }
  const splide = new Splide(targetElm, options);
  splide.mount( { AutoScroll } );
}

const works = () => {
  const targetElm = document.getElementById('js-works');
  if(!targetElm) return;
  const options = {
    type: 'loop',
    speed: 400,
    interval: 3000,
    autoWidth: true,
    arrows: false,
    pagination: false,
    gap: '0.6rem',
    drag: false,
    autoScroll: {
      speed: 1.25,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    reduceMotion: {
      speed: 400,
      interval: 3000,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoScroll: {
        speed: 1.25,
      }
    }
  }
  const splide = new Splide(targetElm, options);
  splide.mount( { AutoScroll } );
}

const comment = () => {
  const targetElm = document.getElementById('js-comment');
  if(!targetElm) return;
  const options = {
    type: 'loop',
    autoplay: false,
    rewind: true,
    speed: 1000,
    arrows: false,
    autoWidth: true,
    gap: '1.2rem',
    pagination: true,
    reduceMotion: {
      speed: 1000,
    }
  }
  const splide = new Splide(targetElm, options);
  splide.mount();

}

export {
  company,
  works,
  comment,
};